import { render, staticRenderFns } from "./KHeader.vue?vue&type=template&id=754b3ff6&scoped=true&lang=pug"
import script from "./KHeader.vue?vue&type=script&lang=js"
export * from "./KHeader.vue?vue&type=script&lang=js"
import style0 from "./KHeader.vue?vue&type=style&index=0&id=754b3ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b3ff6",
  null
  
)

export default component.exports